module.exports = __webpack_public_path__ + "12439d3c81ac46b218c1753d817e10c8.pdf";